// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1du6n","title":"ClientInsurance_title__2MpTY","itemText":"ClientInsurance_itemText__3-D8F"};